export default "__VITE_ASSET__CiEf1oK2__"